import { Select, Spin } from 'antd'
import { useEffect, useState, useRef } from 'react'
import { getSurvivalZone } from 'src/api/survivalzone'

const PAGE_SIZE = 10

const SurvivalZoneSelect = ({
  value,
  onChange,
  placeholder = 'Select Survival Zone',
}) => {
  const [survivalZone, setSurvivalZone] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [hasMore, setHasMore] = useState(true)
  const currentPageRef = useRef(0)

  const loadSurvivalZones = async ({ reset = false, search = '' } = {}) => {
    try {
      setLoading(true)
      const page = reset ? 0 : currentPageRef.current
      const response = await getSurvivalZone(page, PAGE_SIZE, search)
      const newGames = response.data.map((item) => ({
        label: item.title,
        value: item.id,
      }))

      setSurvivalZone((prev) => (reset ? newGames : [...prev, ...newGames]))
      currentPageRef.current = page + 1
      setHasMore(newGames.length === PAGE_SIZE)
    } catch (error) {
      console.error('Failed to load SurvivalZone:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadSurvivalZones({ reset: true })
  }, [])

  const handlePopupScroll = (e) => {
    const target = e.target
    if (
      !loading &&
      hasMore &&
      target.scrollTop + target.offsetHeight >= target.scrollHeight - 50
    ) {
      loadSurvivalZones({ search: searchTerm })
    }
  }

  const handleSearch = (value) => {
    setSearchTerm(value)
    currentPageRef.current = 0
    loadSurvivalZones({ reset: true, search: value })
  }

  const handleClear = () => {
    setSearchTerm('')
    currentPageRef.current = 0
    loadSurvivalZones({ reset: true })
    onChange(undefined)
  }

  return (
    <Select
      showSearch
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      onSearch={handleSearch}
      filterOption={false}
      options={survivalZone}
      style={{ width: '15%', marginLeft: '10px' }}
      onPopupScroll={handlePopupScroll}
      allowClear
      onClear={handleClear}
      loading={loading}
      notFoundContent={loading ? <Spin size="small" /> : null}
    />
  )
}

export default SurvivalZoneSelect
